export function newDate(date, time) {
    date = date.split('-')
    time = time.split(':')
    return new Date(
        parseInt(date[0]),
        parseInt(date[1]) - 1,
        parseInt(date[2]),
        parseInt(time[0]),
        parseInt(time[1]),
    )
}

export function isPassed(year, month, date, hour, minute) {
    return new Date(year, month - 1, date, hour, minute) < new Date()
}

export function UTCToLocal(year, month, date, hour, minute) {
    let localDate = new Date(year, month - 1, date, hour, minute)
    return new Date(localDate.getTime() - (localDate.getTimezoneOffset() * 60000))
}

export function instaplayUTCToLocal(instaplay) {
    const types = ['start', 'winner', 'declare']
    for (let type of types)
        if (instaplay[`${type}Year`]) {
            const date = UTCToLocal(
                instaplay[`${type}Year`],
                instaplay[`${type}Month`],
                instaplay[`${type}Day`],
                instaplay[`${type}Hour`],
                instaplay[`${type}Minute`],
            )
            instaplay[`${type}Minute`] = date.getMinutes()
            instaplay[`${type}Hour`] = date.getHours()
            instaplay[`${type}Day`] = date.getDate()
            instaplay[`${type}Month`] = date.getMonth() + 1
            instaplay[`${type}Year`] = date.getFullYear()
        }
}

export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]

export const dayInMonth = [
    31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31
]
